<template>
	<div :class="$style['BILL_RECEIVE']">
		<pt-form-item label="是否正常:" labelWidth="120px" :required="true">
			<el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
				<el-radio label="QUALIFIED">正常</el-radio>
				<el-radio label="NOT_QUALIFIED">异常</el-radio>
			</el-radio-group>
		</pt-form-item>
    <pt-form-item label="选择原因:" labelWidth="120px" v-if="form.result !== 'QUALIFIED'" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.reason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
		</pt-form-item>
    <pt-form-item label="快递单号：" labelWidth="120px">
      <div v-for="(item,i) in form.courierNumber" :key="i">
        <el-input placeholder="请填写快递单号" v-model="item.value" :class="'courier_'+i"></el-input>
        <el-button style="margin-left:10px" type="text" @click="deleteItem(i)">删除</el-button><br>
        <el-button type="text" @click="addItem(i)" v-show="i==form.courierNumber.length-1">添加一条</el-button>
      </div>
    </pt-form-item>
	</div>
</template>

<script>
import { validate } from 'utils/validate'
import { nextTrust } from '../status.js'
export default {
  props: {
    order: {
      type: Object,
    },
    status: {
      type: String,
      required: true
    },
    selectOrder: [Array],
    isLot: {
      type: Boolean,
      default: false
    },
    billIds: [Array]
  },
  data () {
    return {
      title: '待接收',
      form: {
        result: 'QUALIFIED',
        reason: '',
        // expressNum: ''
        courierNumber: [{ value: '' }],
      },
      reasonProps: {
        label: 'name',
        value: 'value'
      },
      options:[]
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    addItem (index) {
      if (this.form.courierNumber[index].value === '') {
        this.$message.error('请填写快递单号！')
        return
      }
      this.form.courierNumber.push({ value: '' })
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.form.courierNumber.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条快递吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.courierNumber.splice(index, 1)
      })
    },
    next () {
      let data = {
        action: this.status,
        billStatusDetail:{
          action: this.status,
          billStatusResult:this.form.result,
          reason: this.form.result === 'NOT_QUALIFIED' ? this.form.reason : null,
          expressIds:this.form.courierNumber.map(e=>e.value)
        }
      }
      if(this.selectOrder?.length){
        data.orderIds = this.selectOrder.map(e=>e.id)
      }
      if(this.isLot){
        data.billIds = this.billIds
      }else{
        data.billId =  this.order.id
      }
      return nextTrust.call(this, data,this.isLot)
    }
  },
  created () {

  }

}
</script>

<style module lang="less">
.BILL_RECEIVE{
  :global{
    .el-input,
    .el-input__inner {
      width: 280px !important;
    }
  }
}

</style>
